var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("pages-header", {
        ref: "pageHeader",
        attrs: {
          title: _vm.operateMaps[_vm.op] || "-",
          backUrl: _vm.backUrl,
          "close-now-tag": "",
        },
      }),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: "0 20px 20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "formData",
              staticClass: "formData form-boder-padding",
              attrs: {
                rules: _vm.ruleValidate,
                model: _vm.formData,
                "label-width": "200px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品名称：", prop: "name" } },
                        [
                          _c("el-input", {
                            staticClass: "from-ipt-width",
                            attrs: {
                              maxlength: "100",
                              "show-word-limit": "",
                              disabled: _vm.isDisabled,
                              placeholder: "请输入商品名称",
                            },
                            model: {
                              value: _vm.formData.name,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "name",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formData.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品图片：", prop: "image" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "upLoadPicBox acea-row",
                              on: {
                                click: function ($event) {
                                  return _vm.modalPicTap("image")
                                },
                              },
                            },
                            [
                              _vm.formData.image
                                ? _c("div", { staticClass: "pictrue" }, [
                                    _c("img", {
                                      attrs: { src: _vm.formData.image },
                                    }),
                                  ])
                                : _c("div", { staticClass: "upLoad" }, [
                                    _c("i", {
                                      staticClass:
                                        "el-icon-camera cameraIconfont",
                                    }),
                                  ]),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isDisabled,
                                  expression: "!isDisabled",
                                },
                              ],
                              staticClass: "from-tips",
                            },
                            [_vm._v("建议尺寸：280*280px，上传小于1mb的图片")]
                          ),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品价格：", prop: "price" } },
                        [
                          _c("el-input-number", {
                            attrs: {
                              min: 0.01,
                              max: 999999,
                              step: 0.01,
                              "controls-position": "right",
                              "step-strictly": "",
                            },
                            model: {
                              value: _vm.formData.price,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "price",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formData.price",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商城商品ID：", prop: "platId" } },
                        [
                          _c("el-input", {
                            staticClass: "from-ipt-width",
                            attrs: {
                              disabled: _vm.isDisabled,
                              placeholder: "请输入商城商品ID",
                            },
                            model: {
                              value: _vm.formData.platId,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "platId",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "formData.platId",
                            },
                          }),
                          _c("div", { staticClass: "from-tips" }, [
                            _vm._v(
                              "输入积分商城系统【商品-商品列表-商品ID】进行系统关联。注意：商品信息必须对应，请勿输错！"
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "上架状态：", prop: "isShow" } },
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-text": "上架",
                              "inactive-text": "下架",
                              "active-value": true,
                              "inactive-value": false,
                            },
                            model: {
                              value: _vm.formData.isShow,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "isShow", $$v)
                              },
                              expression: "formData.isShow",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: [
                            "platform:system:payment:save",
                            "platform:system:payment:update",
                          ],
                          expression:
                            "['platform:system:payment:save', 'platform:system:payment:update']",
                        },
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isDisabled,
                          expression: "!isDisabled",
                        },
                      ],
                      staticClass: "submission",
                      attrs: { type: "primary", loading: _vm.loadingBtn },
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmit("formData")
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }